module.exports = __webpack_public_path__ + "img/69.bf57d071.jpg";